import React from 'react';
import CardPost from '../Card/CardPost';
import Card from '../Card/Card';
import '../../css/CardPost.css';
import '../../css/GameArea.css';
import '../../css/Card.css';

function GameArea(props) {
    const { cardArray } = props;

    return (
        <div className="gameArea">
            <div className="playArea">
                <div className="playAreaInside">
                    {cardArray.map((data, index1) => {
                        return (
                            data.map((e, index2) => {
                                const cardData = e.split(' ');
                                let color;
                                let translateY;
                                let translateX;
                                const width = window.innerWidth * 0.72 / 8 + 15;
                                switch (index1) {
                                case 0:
                                    translateY = 35 * index2;
                                    translateX = 0;
                                    break;
                                case 1:
                                    translateY = 35 * index2;
                                    translateX = width;
                                    break;
                                case 2:
                                    translateY = 35 * index2;
                                    translateX = width * 2;
                                    break;
                                case 3:
                                    translateY = 35 * index2;
                                    translateX = width * 3;
                                    break;
                                case 4:
                                    translateY = 35 * index2;
                                    translateX = width * 4;
                                    break;
                                case 5:
                                    translateY = 35 * index2;
                                    translateX = width * 5;
                                    break;
                                case 6:
                                    translateY = 35 * index2;
                                    translateX = width * 6;
                                    break;
                                case 7:
                                    translateY = 35 * index2;
                                    translateX = width * 7;
                                    break;
                                default:
                                }
                                switch (cardData[0]) {
                                case '♠':
                                    color = 'spade';
                                    break;
                                case '♥':
                                    color = 'heart';
                                    break;
                                case '♦':
                                    color = 'diamond';
                                    break;
                                default:
                                    color = 'club';
                                    break;
                                }
                                return (
                                    <Card id={`${index1}${index2}`} keyID={index2} card="cards" color={color} colorKind={cardData[0]} number={cardData[1]} translateY={translateY} translateX={translateX} data="drag-drop-container" />
                                );
                            })
                        );
                    })}
                </div>
            </div>
            <div className="waitArea">
                <CardPost outSide="cardPostOut" inside="cardPost" data="drag-drop-container" />
                <CardPost outSide="cardPostOut" inside="cardPost" data="drag-drop-container" />
                <CardPost outSide="cardPostOut" inside="cardPost" data="drag-drop-container" />
                <CardPost outSide="cardPostOut" inside="cardPost" data="drag-drop-container" />
                <CardPost outSide="cardFinalOut" inside="cardFinalPost" content="♦" />
                <CardPost outSide="cardFinalOut" inside="cardFinalPost" content="♣" />
                <CardPost outSide="cardFinalOut" inside="cardFinalPost" content="♥" />
                <CardPost outSide="cardFinalOut" inside="cardFinalPost" content="♠" />
            </div>
        </div>
    );
}

export default GameArea;
